import * as d3 from "d3";
import moment from "moment";

var flatArray = function flatArray(array) {
  return array.map(function (item) {
    var newObj = {};
    Object.keys(item).forEach(function (key) {
      if (typeof item[key] === "object") {
        Object.keys(item[key]).forEach(function (innerKey) {
          newObj["".concat(innerKey)] = item[key][innerKey];
        });
      } else {
        newObj[key] = item[key];
      }
    });
    return newObj;
  });
};

var generateStackedDataBy = function generateStackedDataBy(data, field, stackedBy, acc) {
  //   console.log("generateStackedDataBy prps", data, field, acc);
  var grouped = d3.nest().key(function (d) {
    return d.date.replace("-", "").substr(0, 6);
  }).key(function (d) {
    return d[stackedBy]; //d[groupedBy]
  }).rollup(function (v) {
    return {
      count: v.length,
      total: +d3.sum(v, function (d) {
        var splitted = acc.split(".");
        return splitted.length === 1 ? d[splitted[0]] : d[splitted[0]][splitted[1]];
      }).toFixed(0) // avg: d3.mean(v, (d) => d[acc]).toFixed(0)

    };
  }).entries(data).sort(function (a, b) {
    if (a.key < b.key) {
      return -1;
    } else if (a.key > b.key) {
      return 1;
    } else return 0;
  });
  var res = grouped.map(function (month) {
    return month.values.map(function (category) {
      var newObj = {};
      var key = Object.values(category)[0];
      var total; // sum === 'total' ? (total = Object.values(client)[1].total) : (total = Object.values(client)[1].count);

      newObj[key] = category.value.total;
      newObj.key = month.key;
      return newObj;
    });
  });
  return flatArray(res); //return flatArray(grouped.filter((el) => el.value.total > 1000));
};

var generateStackedGroupDataBy = function generateStackedGroupDataBy(data, field, stackedBy, acc) {
  //   console.log("generateStackedDataBy prps", data, field, acc);
  var grouped = d3.nest().key(function (d) {
    return d.date.substring(5, 7);
  }).key(function (d) {
    return d[stackedBy]; //d[groupedBy]
  }).rollup(function (v) {
    return {
      count: v.length,
      total: +d3.sum(v, function (d) {
        var splitted = acc.split(".");
        return splitted.length === 1 ? d[splitted[0]] : d[splitted[0]][splitted[1]];
      }).toFixed(0) // avg: d3.mean(v, (d) => d[acc]).toFixed(0)

    };
  }).entries(data).sort(function (a, b) {
    if (a.key < b.key) {
      return -1;
    } else if (a.key > b.key) {
      return 1;
    } else return 0;
  });
  var res = grouped.map(function (month) {
    return month.values.map(function (category) {
      var newObj = {};
      var key = Object.values(category)[0];
      var total; // sum === 'total' ? (total = Object.values(client)[1].total) : (total = Object.values(client)[1].count);

      newObj[key] = category.value.total;
      newObj.key = month.key;
      return newObj;
    });
  });
  return flatArray(res); //return flatArray(grouped.filter((el) => el.value.total > 1000));
};

var generateBarChartDataByMonth = function generateBarChartDataByMonth(acc, data) {
  // console.log("generateBarChartDataByMonth acc", acc);
  d3.nest().key(function (d) {
    return d.date.replace("-", "").substr(0, 6);
  }).rollup(function (v) {
    return {
      type: v[0].type,
      count: v.length,
      total: +d3.sum(v, function (d) {
        return d[acc]; // const splitted = acc.split(".");
        // return splitted.length === 1
        //   ? d[splitted[0]]
        //   : d[splitted[0]][splitted[1]];
      }).toFixed(0) // avg: d3.mean(v, (d) => d[acc]).toFixed(0)

    };
  }).entries(data).sort(function (a, b) {
    if (a.key < b.key) {
      return -1;
    } else if (a.key > b.key) {
      return 1;
    } else return 0;
  });
}; // const createInvoiceDashboard = (invoices, key = "category") => {
//   d3.nest()
//     .key(d => d.key)
//     .rollup(v => {
//       return {
//         count: v.length,
//         total: +d3
//           .sum(v, d => {
//             return d.subtotal;
//             // const splitted = acc.split(".");
//             // return splitted.length === 1
//             //   ? d[splitted[0]]
//             //   : d[splitted[0]][splitted[1]];
//           })
//           .toFixed(0)
//         // avg: d3.mean(v, (d) => d[acc]).toFixed(0)
//       };
//     })
//     .entries(invoices)
//     .sort((a, b) => {
//       if (a.key < b.key) {
//         return -1;
//       } else if (a.key > b.key) {
//         return 1;
//       } else return 0;
//     });
// };


export { flatArray, generateStackedDataBy, generateBarChartDataByMonth, generateStackedGroupDataBy };